<div class="modal-container" [class.is-hidden]="isHidden">
  <div class="modal-header">
    <h5>{{ title }}</h5>
    <i class="fas fa-times" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <ng-content></ng-content>
  </div>
</div>

<div class="modal-overlay" (click)="close()" [class.is-hidden]="isHidden"></div>
